import CoreUser from "models/CoreUser";
class MetaData {
    createdBy;
    createdDate;
    id;
    lastModifiedBy;
    lastModifiedDate;
    permissions;
    constructor(response) {
        if (response?.createdBy !== undefined)
            this.createdBy = new CoreUser(response.createdBy);
        if (response?.createdDate !== undefined)
            this.createdDate = response.createdDate;
        if (response?.id !== undefined)
            this.id = response.id;
        if (response?.lastModifiedBy !== undefined)
            this.lastModifiedBy = new CoreUser(response.lastModifiedBy);
        if (response?.lastModifiedDate !== undefined)
            this.lastModifiedDate = response.lastModifiedDate;
        if (response?.permissions !== undefined)
            this.permissions = response.permissions;
    }
    static #equalDates(dateA, dateB) {
        if (dateA === undefined && dateB === undefined) {
            return true;
        }
        if (dateA === undefined || dateB === undefined) {
            return false;
        }
        const data1 = new Date(dateA);
        const date2 = new Date(dateB);
        return Math.abs(data1.getTime() - date2.getTime()) < 1000;
    }
    static equals(metaA, metaB) {
        return CoreUser.equals(metaA.createdBy, metaB.createdBy) && MetaData.#equalDates(metaA.createdDate, metaB.createdDate) && metaA.id === metaB.id &&
            CoreUser.equals(metaA.lastModifiedBy, metaB.lastModifiedBy) && MetaData.#equalDates(metaA.lastModifiedDate, metaB.lastModifiedDate);
    }
}
export default MetaData;
